import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_BASE_URL } from '@/app/core/http/api-base-url.token';
import { AuthHttpClient } from '@/app/core/http/auth-http-client';
import { PageRequest } from '@/app/core/models/paged-result.model';
import {
  PendingBonusDetail,
  PendingBonusFilters,
  PendingBonusResult,
} from '../models/pending-bonus.model';
import { IssuedPayroll } from '../models/issued-payroll.model';
import {
  IssueBonusesApiRequest,
  IssuedPayrollApiResponse,
  PendingBonusApiResponse,
  PendingBonusDetailApiResponse,
} from './pending-bonus-api.types';
import {
  toApiQueryParams,
  toIssuedPayroll,
  toPendingBonusDetail,
  toPendingBonusResult,
} from './pending-bonus.mapper';
import { PendingBonusRepository } from './pending-bonus.repository';

@Injectable()
export class PendingBonusHttpRepository extends PendingBonusRepository {
  private readonly http = inject(AuthHttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  override search(filters: PendingBonusFilters, page: PageRequest): Observable<PendingBonusResult> {
    return this.http
      .get<PendingBonusApiResponse>(`${this.baseUrl}/bonos/pendientes`, {
        params: toApiQueryParams(filters, page),
      })
      .pipe(map(toPendingBonusResult));
  }

  override getDetail(folio: string): Observable<PendingBonusDetail> {
    return this.http
      .get<PendingBonusDetailApiResponse>(
        `${this.baseUrl}/bonos/pendientes/${encodeURIComponent(folio)}`,
      )
      .pipe(map(toPendingBonusDetail));
  }

  override issue(folios: readonly string[], idempotencyKey: string): Observable<IssuedPayroll> {
    const body: IssueBonusesApiRequest = { folios: [...folios] };
    return this.http
      .post<IssuedPayrollApiResponse>(`${this.baseUrl}/bonos/emitir`, body, {
        headers: new HttpHeaders({ 'Idempotency-Key': idempotencyKey }),
      })
      .pipe(map(toIssuedPayroll));
  }
}
